import { useQuery } from "@tanstack/react-query";

import { apiRequest } from "@/lib/api";
import type { Schemas } from "@/types/api";
import { useMutationWithToast } from "@/hooks/shared/use-mutation-with-toast";

export type ImpersonationTarget = Schemas["ImpersonationTarget"];

/** Colaboradores que o superadmin pode personificar. */
export const useImpersonationTargets = (search: string, enabled: boolean) =>
  useQuery({
    queryKey: ["impersonation-targets", search],
    queryFn: () => {
      const qs = search ? `?search=${encodeURIComponent(search)}` : "";
      return apiRequest<ImpersonationTarget[]>(`/auth/impersonate/targets${qs}`);
    },
    enabled,
  });

/**
 * Começa/pára de ver a app como outra pessoa.
 *
 * Recarrega a página em vez de invalidar queries: a sessão muda por completo
 * (permissões, menus, dados) e um recarregamento garante que nada fica em cache
 * do utilizador anterior.
 */
export const useStartImpersonation = () =>
  useMutationWithToast({
    mutationFn: (userId: string) => apiRequest(`/auth/impersonate/${userId}`, { method: "POST" }),
    onSuccessCallback: () => window.location.assign("/dashboard"),
  });

export const useStopImpersonation = () =>
  useMutationWithToast({
    mutationFn: () => apiRequest("/auth/impersonate/stop", { method: "POST" }),
    onSuccessCallback: () => window.location.assign("/dashboard"),
  });
